import { useEffect } from 'react';
import { resizeIframeDebounced } from '../../Utils';

function Resizer({ width }) {
  useEffect(() => {
    resizeIframeDebounced();
  }, [width]);

  return null;
}

export default Resizer;
